<template>
  <div class='templateManagement'>
    <sky-tabs v-model="tabValue"
              :tabList="tabList">
    </sky-tabs>
    <component :is="tabValue"></component>
  </div>
</template>

<script>
import templateManage from '@/components/website/templateManage'
import skyTabs from "@/components/iglobalwin/formComponents/tabs/sky-tabs.vue";

export default {
  name: 'templateManagement',
  components: {
    ...templateManage,
    skyTabs
  },
  data () {
    return {
      tabValue: 'myClient',
      tabList: [
        {
          label: "我的客户",
          name: "myClient"
        },
        {
          label: "我的模板",
          name: "myTemplate"
        }
      ],
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(from.name === 'templateEditor') vm.tabValue = 'myTemplate'
    })
  }
}
</script>

<style lang='scss' scoped>
.templateManagement {
	background-color: #fff;

	.sky-tabs {
		border-bottom: 2px solid #e4e7ed !important;
	}
}
</style>
